/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DeleteRecordsJobConfig } from "./DeleteRecordsJobConfig";
import { FileJobConfig } from "./FileJobConfig";
import { PipelineJobConfig } from "./PipelineJobConfig";
import { ExportJobConfig } from "./ExportJobConfig";
import { MutateJobConfig } from "./MutateJobConfig";
import { FindAndReplaceJobConfig } from "./FindAndReplaceJobConfig";
import { MappingProgramJobConfig } from "./MappingProgramJobConfig";
import { AiGenerateBlueprintJobConfig } from "./AiGenerateBlueprintJobConfig";
import { AiGenerateSampleDataJobConfig } from "./AiGenerateSampleDataJobConfig";
import { AiGenerateBlueprintConstraintsJobConfig } from "./AiGenerateBlueprintConstraintsJobConfig";
import { AiGenerateConstraintJobConfig } from "./AiGenerateConstraintJobConfig";
import { AiRuleCreationJobConfig } from "./AiRuleCreationJobConfig";
import { CaptureRoutineJobConfig } from "./CaptureRoutineJobConfig";
import { RunRunbookJobConfig } from "./RunRunbookJobConfig";
import { MappingFromPreprocessingJobConfig } from "./MappingFromPreprocessingJobConfig";
import { EmptyObject } from "./EmptyObject";
import { AddRecordsToDataClipJobConfig } from "./AddRecordsToDataClipJobConfig";
import { UpdateDataClipResolutionsJobConfig } from "./UpdateDataClipResolutionsJobConfig";
import { AgentExportJobConfig } from "./AgentExportJobConfig";
import { AgentPromotionJobConfig } from "./AgentPromotionJobConfig";
import { CompanyResearchJobConfig } from "./CompanyResearchJobConfig";
import { ConfigureDemoJobConfig } from "./ConfigureDemoJobConfig";
import { BulkMutateFlagsJobConfig } from "./BulkMutateFlagsJobConfig";
export const JobUpdateConfig = core.serialization.undiscriminatedUnion([
    DeleteRecordsJobConfig,
    FileJobConfig,
    PipelineJobConfig,
    ExportJobConfig,
    MutateJobConfig,
    FindAndReplaceJobConfig,
    MappingProgramJobConfig,
    AiGenerateBlueprintJobConfig,
    AiGenerateSampleDataJobConfig,
    AiGenerateBlueprintConstraintsJobConfig,
    AiGenerateConstraintJobConfig,
    AiRuleCreationJobConfig,
    CaptureRoutineJobConfig,
    RunRunbookJobConfig,
    MappingFromPreprocessingJobConfig,
    EmptyObject,
    AddRecordsToDataClipJobConfig,
    UpdateDataClipResolutionsJobConfig,
    AgentExportJobConfig,
    AgentPromotionJobConfig,
    CompanyResearchJobConfig,
    ConfigureDemoJobConfig,
    BulkMutateFlagsJobConfig,
]);
